module.exports = __webpack_public_path__ + "static/media/cancel_white.f265abe7.svg";